import store from "@/state/store";

export default [
  {
    path: "/",
    name: "home",
    component: () => import("./views/public/home"),
  },
  {
    path: "/precios",
    name: "publicPrices",
    component: () => import("./views/public/prices"),
  },
  {
    path: "/empresa",
    name: "publicCompany",
    component: () => import("./views/public/company"),
  },
  {
    path: "/app",
    name: "default",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "MESERO", "CAJERO", "CONTABILIDAD"],
    },
    component: () => import("./views/admin/suite-dashboard"),
  },
  {
    path: "/orders",
    name: "orders",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "MESERO", "CAJERO"],
      solutionKeys: ["tootable"],
    },
    component: () => import("./views/product/orders"),
  },
  {
    path: "/order/:idOrder/add/items",
    name: "additems",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "MESERO"],
      activeMenu: "/orders",
    },
    //component: () => import("./views/dashboards/default"),
    component: () => import("./views/product/products"),
  },
  {
    path: "/tables",
    name: "tables",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "MESERO", "CAJERO"],
    },
    component: () => import("./views/product/tables"),
  },
  {
    path: "/order/:idOrder/checkout/:total/:propina/:orderString",
    name: "checkout2",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "MESERO", "CAJERO"],
      activeMenu: "/orders",
    },
    //component: () => import("./views/dashboards/default"),
    component: () => import("./views/product/checkout2"),
  },
  {
    path: "/kitchen",
    name: "kitchen",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "COCINA"],
      solutionKeys: ["tootable"],
      capability: "kitchen",
      capabilitySolutionKey: "tootable",
    },
    component: () => import("./views/kitchen/kitchen"),
  },
  {
    path: "/products/items",
    name: "allproducts",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
    },
    //component: () => import("./views/dashboards/default"),
    component: () => import("./views/product/list-product-update"),
  },
  {
    path: "/products/item/new",
    name: "createProduct",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
      activeMenu: "/products/items",
    },
    component: () => import("./views/product/add-product"),
  },
  {
    path: "/products/item/:idProduct",
    name: "updateProduct",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
      activeMenu: "/products/items",
    },
    //component: () => import("./views/dashboards/default"),
    component: () => import("./views/product/update-product"),
  },
  {
    path: "/inventory",
    name: "inventory",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
    },
    component: () => import("./views/inventory/inventory"),
  },
  {
    path: "/retail",
    name: "retail",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "CAJERO", "CONTABILIDAD"],
      solutionKeys: ["tooretail"],
      activeMenu: "/app",
    },
    component: () => import("./views/admin/suite-dashboard"),
  },
  {
    path: "/retail/sales",
    name: "retailSales",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "CAJERO"],
      solutionKeys: ["tooretail"],
    },
    component: () => import("./views/retail/retail-sales"),
    props: { initialTab: "active" },
  },
  {
    path: "/retail/sales/history",
    name: "retailSalesHistory",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "CAJERO"],
      solutionKeys: ["tooretail"],
    },
    component: () => import("./views/retail/retail-sales"),
    props: { initialTab: "history" },
  },
  {
    path: "/retail/sales/receivables",
    name: "retailReceivables",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "CAJERO", "CONTABILIDAD"],
      solutionKeys: ["tooretail"],
      capability: "accountsReceivable",
      capabilitySolutionKey: "tooretail",
    },
    component: () => import("./views/retail/retail-receivables"),
  },
  {
    path: "/retail/products",
    name: "retailProducts",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
      solutionKeys: ["tooretail"],
      activeMenu: "/retail/inventory",
    },
    component: () => import("./views/retail/retail-inventory"),
  },
  {
    path: "/retail/inventory",
    name: "retailInventory",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
      solutionKeys: ["tooretail"],
    },
    component: () => import("./views/retail/retail-inventory"),
  },
  {
    path: "/retail/purchases",
    name: "retailPurchases",
    meta: {
      authRequired: true,
      roles: ["ADMIN"],
      solutionKeys: ["tooretail"],
      capability: "purchases",
      capabilitySolutionKey: "tooretail",
    },
    component: () => import("./views/retail/retail-purchases"),
    props: { mode: "new" },
  },
  {
    path: "/retail/purchases/history",
    name: "retailPurchasesHistory",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "CONTABILIDAD"],
      solutionKeys: ["tooretail"],
      capability: "purchases",
      capabilitySolutionKey: "tooretail",
    },
    component: () => import("./views/retail/retail-purchases"),
    props: { mode: "history" },
  },
  {
    path: "/retail/purchases/payables",
    name: "retailPayables",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "CONTABILIDAD"],
      solutionKeys: ["tooretail"],
      capability: "accountsPayable",
      capabilitySolutionKey: "tooretail",
    },
    component: () => import("./views/retail/retail-payables"),
  },
  {
    path: "/admin/restaurants",
    name: "restaurants",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
    },
    component: () => import("./views/admin/restaurants"),
  },
  {
    path: "/admin/users",
    name: "users",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
    },
    component: () => import("./views/admin/users"),
  },
  {
    path: "/admin/subscription",
    name: "subscription",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
    },
    component: () => import("./views/admin/subscription"),
  },
  {
    path: "/admin/plans",
    name: "plans",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
    },
    component: () => import("./views/admin/plans"),
  },
  {
    path: "/admin/subscription/payment-return",
    name: "subscriptionPaymentReturn",
    meta: {
      activeMenu: "/admin/subscription",
    },
    component: () => import("./views/admin/subscription-payment-return"),
  },
  {
    path: "/admin/floorplans",
    name: "floorplans",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
      solutionKeys: ["tootable"],
      capability: "floorplans",
      capabilitySolutionKey: "tootable",
    },
    component: () => import("./views/admin/floorplans"),
  },
  {
    path: "/admin/reports",
    name: "reports",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN", "CONTABILIDAD"],
    },
    component: () => import("./views/admin/reports"),
  },
  {
    path: "/admin/reports/charts",
    name: "reportCharts",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN", "CONTABILIDAD"],
      capability: "statistics",
    },
    component: () => import("./views/admin/report-charts"),
  },
  {
    path: "/admin/accounting",
    name: "accounting",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN", "CONTABILIDAD"],
      capability: "accounting",
    },
    component: () => import("./views/admin/accounting"),
  },
  {
    path: "/admin/accounting/movements",
    name: "accountingMovements",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN", "CONTABILIDAD"],
      capability: "accounting",
      activeMenu: "/admin/accounting",
    },
    component: () => import("./views/admin/accounting-movements"),
  },
  {
    path: "/admin/receipt",
    name: "receiptSettings",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
    },
    component: () => import("./views/admin/receipt-settings"),
  },
  {
    path: "/admin/notifications",
    name: "notifications",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "SUPERADMIN"],
    },
    component: () => import("./views/admin/notifications"),
  },
  {
    path: "/order/invoice",
    name: "invoiceDetail",
    meta: {
      authRequired: true,
      roles: ["ADMIN", "MESERO", "CAJERO"],
      activeMenu: "/orders",
    },
    //component: () => import("./views/dashboards/default"),
    component: () => import("./views/product/detail-invoice"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("./views/account/logout"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        next({ name: "home" });
      },
    },
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  // {
  //   path: "*",
  //   redirect: "404",
  // },
  {
    path: "/auth/login-1",
    name: "Login sample",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/login-sample"),
  },
  {
    path: "/auth/login-2",
    name: "Login-2-sample",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/login-2"),
  },
  {
    path: "/auth/register-1",
    name: "Register sample",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/register-sample"),
  },
  {
    path: "/auth/register-2",
    name: "Register-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/register-2"),
  },
  {
    path: "/auth/recoverpwd",
    name: "Recover pwd",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/recoverpw-sample"),
  },
  {
    path: "/auth/recoverpwd-2",
    name: "Recover pwd-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/recoverpwd-2"),
  },
  {
    path: "/auth/lock-screen",
    name: "Lock screen",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/lockscreen"),
  },
  {
    path: "/auth/lock-screen-2",
    name: "Lock screen-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/lockscreen-2"),
  },
  {
    path: "/auth/confirm-mail",
    name: "confirm-mail",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/confirm-mail"),
  },
  {
    path: "/auth/confirm-mail-2",
    name: "confirm-mail-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/confirm-mail-2"),
  },
  {
    path: "/auth/email-verification",
    name: "email-verification",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/email-verification"),
  },
  {
    path: "/auth/email-verification-2",
    name: "email-verification-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/email-verification-2"),
  },
  {
    path: "/auth/two-step-verification",
    name: "two-step-verification",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/two-step-verification"),
  },
  {
    path: "/auth/two-step-verification-2",
    name: "two-step-verification-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/two-step-verification-2"),
  },
  {
    path: "/pages/starter",
    name: "Starter",
    meta: { authRequired: true },
    component: () => import("./views/utility/starter"),
  },
  {
    path: "/pages/maintenance",
    name: "Maintenance",
    meta: { authRequired: true },
    component: () => import("./views/utility/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { authRequired: true },
    component: () => import("./views/utility/coming-soon"),
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("./views/utility/500"),
  },
];
